import { AppReducerStateProps, store } from "lib/store";
import { chatActionTypes } from "lib/store/chat/reducer";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";

interface ChatImgModalProps {
  state: AppReducerStateProps;
  closeModal: Function;
}

export const alertChatImageModal = (imgchat: string) => {
  store.dispatch({
    type: chatActionTypes.ACTION_OPEN_MODAL_CHAT,
    payload: imgchat,
  });
};

function ChatImgModal(props: ChatImgModalProps) {
  const { closeModal } = props;
  const { isModalChatImage, chatImage } = props.state.chat;

  return (
    <Modal
      {...props}
      size="lg"
      scrollable={true}
      contentClassName="view-background-chat"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={isModalChatImage}
      onHide={() => {
        closeModal();
      }}
      dialogClassName="modal-chat"
    >
      <Modal.Header closeButton className="modal-header">
        <Modal.Title id="example-modal-sizes-title-lg"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row center-row-content col-12 col-md-6 col-lg-6">
          <img
            style={{ height: "auto", width: "100%", marginTop: 50 }}
            src={chatImage}
          ></img>
        </div>
        <button
          style={{ marginTop: 10 }}
          className="btn btn-purple-close-chat col-12 col-md-6 col-lg-6 center-row-content"
          title="ปิด"
          onClick={() => {
            closeModal();
          }}
        >
          ปิด
        </button>
      </Modal.Body>
      <Modal.Footer className="modal-footer"></Modal.Footer>
    </Modal>
  );
}

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    closeModal: () => {
      dispatch({
        type: chatActionTypes.ACTION_CLOSE_MODAL_CHAT,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatImgModal);
